import { get, intersection, isEmpty, isNumber, last, map, noop } from 'lodash';
import { useQueryClient, useSocketEventsDebounced, useSocketEventsThrottled } from '@lumahealthhq/ui-model';
import { useLogger } from '@lumahealthhq/ui-utils';
var unreadEvents = ['created', 're-assigned', 'new-message'];
export default function useSocketEventsHandler() {
  var queryClient = useQueryClient();
  var logger = useLogger();

  // chatActivities counter updates
  useSocketEventsThrottled(['chat:server:chatActivity'], function (events) {
    logger.debug('useSocketEventsThrottled:chatActivity', events);
    var event = last(events);

    // Update the data for `useChatActivityCountUnassigned` queries
    if (isNumber(event == null ? void 0 : event.unassignedCount)) {
      queryClient.setQueriesData({
        queryKey: 'chatActivities/unassigned'
      }, event.unassignedCount);
    } else {
      // Invalidate query when event.unassignedCount is undefined
      queryClient.invalidateQueries('chatActivities/unassigned')["catch"](noop);
    }

    // External events that should refresh the lists and counters
    if (!isEmpty(intersection(map(events, 'action'), unreadEvents))) {
      // Invalidate /unread counter
      queryClient.invalidateQueries('chatActivities/unread')["catch"](noop);

      // Invalidate chatActivities
      queryClient.invalidateQueries('chatActivities')["catch"](noop);
    }
  },
  // FE is handling the counters on local changes
  // External changes will take at maximum 10s to appear
  10 * 1000 // 10 seconds
  );

  // messages with patientId (invalidate only for the specific patient)
  useSocketEventsDebounced(['chat:client:inbound:message', 'chat:server:outbound:message', 'chat:server:outbound:message:mention'], function (events) {
    logger.debug('useSocketEventsDebounced:messages', events);
    events.forEach(function (event) {
      var _ref = event,
        patient = _ref.patient;
      queryClient.invalidateQueries(['messages', {
        patient: patient
      }])["catch"](noop);
    });
  });

  // messages with nomPatientId (invalidate only for the patient on chatActivity object)
  useSocketEventsThrottled(['chat:server:chatActivity'], function (events) {
    logger.debug('useSocketEventsThrottled:messages', events);
    events.forEach(function (event) {
      var _ref2 = event,
        chatActivity = _ref2.chatActivity,
        action = _ref2.action;
      if (chatActivity && !action) {
        var patient = get(chatActivity, 'patient', '');
        if (patient) {
          queryClient.invalidateQueries(['messages', {
            patient: patient
          }])["catch"](noop);
        }
      }

      // Invalidate patient query for when in patient profile reopening or creating a chat from sending a new message
      if (chatActivity && (action === 'reopened' || action === 'created')) {
        var _patient = get(chatActivity, 'patient', '');
        if (_patient) {
          queryClient.invalidateQueries(['patients', {
            _id: _patient
          }])["catch"](noop);
        }
      }

      // Invalidate patient query for when in patient profile reopening or creating a chat from sending a new message
      if (chatActivity && action === 'new-message') {
        var _patient2 = get(chatActivity, 'patient', '');
        if (_patient2) {
          queryClient.invalidateQueries(['messages', {
            ref: 'assistant'
          }])["catch"](noop);
        }
      }
    });
  });

  // invalidate all messages
  useSocketEventsDebounced(['chat:server:inbound:message:replyToAutomated', 'chat:server:outbound:message:automated'], function (events) {
    logger.debug('useSocketEventsDebounced:messages', events);
    queryClient.invalidateQueries('messages')["catch"](noop);
  });
}